import { render, staticRenderFns } from "./LegalDocumentModalComponent.vue?vue&type=template&id=48a8ca75&scoped=true&"
import script from "./LegalDocumentModalComponent.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentModalComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a8ca75",
  null
  
)

export default component.exports